import { Box } from '@mui/material';
import { CSSProperties, ReactNode, useMemo } from 'react';

import { COLORS } from '@/styles/tokens/colors';
import { UnreachableError } from '@/utils/errors';

interface Props {
  size: number;
  icon: ReactNode;
  colors: {
    background: string;
    iconColor?: string;
  };
  variant?: 'default' | 'square';
  squareRadius?: CSSProperties['borderRadius'];
}

export function Medallion({
  size,
  icon,
  colors,
  variant = 'default',
  squareRadius,
}: Props) {
  const borderRadius = useMemo(() => {
    switch (variant) {
      case 'default':
        return size / 2;
      case 'square':
        return squareRadius || '6px';
      default:
        throw new UnreachableError({
          case: variant,
          message: 'Invalid variant provided to medallion',
        });
    }
  }, [size, squareRadius, variant]);

  return (
    <Box
      display="flex"
      bgcolor={colors.background}
      width={size}
      minWidth={size}
      height={size}
      borderRadius={borderRadius}
      justifyContent="center"
      alignItems="center"
      color={colors.iconColor ?? COLORS.PRIMITIVES.WHITE}
    >
      {icon}
    </Box>
  );
}
